import Metadata from './01-Metadata';
import Language from './02-Language';
import Sources from './03-Sources';
import Keywords from './04-Keywords';
import Tags from './05-Tags';
import Sentiment from './06-Sentiment';

export { Keywords as DocumentKeywords, Language, Metadata, Sentiment, Sources, Tags };
